import { MedicalCardRequirement } from 'src/constants/collect-data/enums'
import type { PartnerDriverStep } from 'src/interfaces/partnerDriver'

/**
 * The DOT medical card setting of a `dot_number` step. No setting means required — the backend's
 * `CollectDataStepService.getMedicalCardRequirement` default, and the client app's.
 */
export const getMedicalCardRequirement = (step: PartnerDriverStep): MedicalCardRequirement => {
  return step.metadata?.medicalCardRequirement ?? MedicalCardRequirement.Required
}
